import { useMiiaFwS3 } from '@/features/miiaFw/composables/useMiiaFwS3'
import MiiaFwConfig from '@/configs/config'

/**
 * S3のKeyからダウンロードする。
 * @param key バケット内のオブジェクトキー
 * @param filename ダウンロード時のファイル名。指定しない場合はURLから抽出し、抽出できなかった場合は'download'とする。
 */
export async function downloadFromkey(key: string, filename?: string): Promise<void> {
  const miiaFwS3 = useMiiaFwS3()

  const bucketParam = {
    name: MiiaFwConfig.config.s3Access.contentsBucketEmergency,
    prefix: '',
    delimiter: '/'
  }
  const result = await miiaFwS3.downloadObject(bucketParam, key, 'blob')
  downloadFile(result, filename || key.split('/').pop() || 'download')
}

/**
 * Blob又はMediaSourceをダウンロードする。
 * @param data ダウンロード対象のオブジェクト
 * @param filename ダウンロード時のファイル名
 */
export function downloadFile(data: Blob | MediaSource, filename: string): void {
  const downloadUrl = URL.createObjectURL(data)
  try {
    const a = document.createElement('a')
    a.href = downloadUrl
    a.download = filename
    document.body.appendChild(a)
    a.click()
    a.remove()
  } finally {
    URL.revokeObjectURL(downloadUrl)
  }
}
